import { render, staticRenderFns } from "./ChargingPointsTable.vue?vue&type=template&id=237e133b&scoped=true&"
import script from "./ChargingPointsTable.vue?vue&type=script&lang=js&"
export * from "./ChargingPointsTable.vue?vue&type=script&lang=js&"
import style0 from "./ChargingPointsTable.vue?vue&type=style&index=0&id=237e133b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237e133b",
  null
  
)

export default component.exports